import config from "../config"
const base_url = config.base_url
export const getReferralData = () =>{
    return fetch(base_url + "user/referral/info", {
      method: 'POST',
      mode: 'cors',
      headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-type': 'application/x-www-form-urlencoded',
          'credentials': 'include'
      },
      credentials: 'include',
    })
  }
export const getReferralAgencyData = () =>{
  return fetch(base_url + "user/referral/agency/data", {
    method: 'POST',
    mode: 'cors',
    headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-type': 'application/x-www-form-urlencoded',
        'credentials': 'include'
    },
    credentials: 'include',
  })
}